module.exports = __webpack_public_path__ + "static/vcdlogo-d11184b0c89ff336e31e90fb07e80614.png";